import {ApplicationStoreType} from 'desktop/store';

import {getSuccessPageState} from '../selectors';

/**
 * Returns the order items stored - is empty unless order updated
 */
export const getOrderItems = (store: ApplicationStoreType) =>
    getSuccessPageState(store).orderStatus?.items || [];

/**
 * Returns if the buttons should display a loading state
 */
export const getOrderLoading = (store: ApplicationStoreType) =>
    getSuccessPageState(store).orderStatus.isLoading;

/**
 * Returns if there was an error when saving order
 */
export const getOrderError = (store: ApplicationStoreType) =>
    getSuccessPageState(store).orderStatus.isError;
